import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import './ProductCard.css';
import {defaultImage} from '../../utils/Utils'

export default function ProductCard({ product, endPoint }) {
  // Safely extract product properties with fallbacks
  const { name, price, picture, persons } = product || {};
  
  // Debug: Check what we receive
  if (name === 'כוס קרסטל 250') {
    console.log('=== ProductCard DEBUG ===');
    console.log('Product prop:', product);
    console.log('Picture from destructuring:', picture);
    console.log('Picture type:', typeof picture);
    console.log('Picture value:', JSON.stringify(picture));
    console.log('All product keys:', Object.keys(product || {}));
  }
  
  // Normalize picture path: remove leading slash if present, then add /products/ prefix
  // Encode the path properly for URLs with Hebrew characters
  let defaultPic;
  // More robust check for picture field
  const hasValidPicture = picture != null && 
                          typeof picture === 'string' && 
                          picture.trim().length > 0;
  
  if (hasValidPicture) {
    const normalizedPath = picture.startsWith('/') ? picture.slice(1) : picture;
    // Split path and encode each segment separately to preserve slashes
    const pathSegments = normalizedPath.split('/').map(segment => encodeURIComponent(segment));
    defaultPic = `/products/${pathSegments.join('/')}`;
  } else {
    defaultPic = `/${defaultImage}`;
  }

  const personIcons = [];
  for (let i = 0; i < persons; i++) {
    personIcons.push(<PersonIcon key={i} fontSize='small' />);
  }

  return (
    <div className="food-card" data-aos={`zoom-in`} data-aos-duration="1000">
      <div className="food-card-logo-container">
        <img className="logo" src={`${endPoint}/logo.webp`} alt="Logo" />
        <div className='persons-number'>
          {/* {personIcons} */}
        </div>
      </div>
      <div className="food-card-img-container">
        <img src={`${endPoint}${defaultPic}`} alt="Product" />
        <div className="food-card-title-container">
          <h3 className="food-card-title">{name}</h3>
          <p className="food-card-price">₪{price}</p>
        </div>
      </div>
    </div>
  );
}